var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "d-flex bg-greige p-1 mb-1" }, [
      _c("p", { class: _vm.pictoClass }, [
        _c("span", { staticClass: "icon-rewards me-1 font-size-32" }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _vm.promoTitle && _vm.promoSubtitle
            ? _c("div", { staticClass: "col-auto ps-1" }, [
                _c("p", { staticClass: "d-flex flex-column mb-0" }, [
                  _c("span", { staticClass: "font-size-16 fw-bold" }, [
                    _vm._v(_vm._s(_vm.promoTitle)),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "font-size-16" }, [
                    _vm._v(_vm._s(_vm.promoSubtitle)),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.odrTitle && _vm.odrSubtitle
            ? _c("div", { staticClass: "col-auto ps-1" }, [
                _c("p", { staticClass: "d-flex flex-column mb-0" }, [
                  _c("span", { staticClass: "font-size-16 fw-bold" }, [
                    _vm._v(_vm._s(_vm.odrTitle)),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "font-size-16" }, [
                    _vm._v(_vm._s(_vm.odrSubtitle)),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "col-auto ms-sm-auto me-2 mt-auto text-sm-end ps-1 pt-0",
            },
            [
              _c("ob1-liens", {
                attrs: {
                  text: _vm.linkLabel,
                  "is-button": "",
                  "is-dark-link": _vm.withDarkLink,
                  "with-arrow": "",
                  "modal-id": _vm.modalId,
                },
                on: {
                  "ob1-liens-click": function ($event) {
                    return _vm.$emit("promo-odr-click")
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm._t("default"),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }